module.exports = "/_next/static/images/voyager-2cfb421eb3d97acec41b6ef8e5aee50c.png";